import { signOnboardingDocSuccess } from 'src/app/core/store/onboardingdocs/onboardingdocs.actions';
import { PagingResultsModel } from './../../../models/pagingResultsModel';
import { BenefitPlanEllegibilityWaitingPeriodModel, BenefitPlanModel, BenefitPlanTypeModel, BenefitPlanEllegibilityBeginModel, BenefitPlanTerminationUponModel, BenefitPlanFullModel, BenefitPlanCoverageLevelModel, BenefitsDependentModel, BenefitPlanDeclineReasonModel, BenefitPlanEnrollmentSetModel, EmployerContributionModel, BenefitClassModel, BenefitPlanFormDocumentsEnrollmentModel, BenefitsSettingsModel, BenefitStatusCheckModel, BenefitPlanUserWithEnrollmentSetModel, BenefitsLifeChangingEventModel, BenefitPlanDeclinedReportModel, BenefitPlanWithdrawnReportModel, BenefitLogReportModel, BenefitHsaReportModel, CarrierBenefitPlanModel } from './../../../models/benefitsModels';
import { UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';
import { createReducer, on, Action } from '@ngrx/store';
import { deepClone, getAllControlsErrors } from 'src/app/helpers/utils';
import { FormError } from 'src/app/models/utilModels';
import {
  addBenefitPlanCost, addBenefitPlanDocument, addBenefitPlanLink, clearBenefitsPlanInfo, loadBenefitsPlanInfo, loadBenefitsPlanInfoFail, loadBenefitsPlanInfoSuccess, loadBenefitsPlans, loadBenefitsPlansFail, loadBenefitsPlansSuccess, loadBenfitPlanTypesSuccess, loadCoverageLevelsSuccess, loadElegibilityBeginsSuccess, loadElegibilityWaitingPeriodsSuccess, loadTerminationUponsSuccess, removeBenefitPlanCost, removeBenefitPlanDocument, removeBenefitPlanLink, saveBenefitsPlan, saveBenefitsPlanFail, saveBenefitsPlanSuccess, updateBenefitsPlanForm, loadBenefitsDependents, loadBenefitsDependentsSuccess, loadBenefitsDependentsFail, loadBenefitsDependentInfo, loadBenefitsDependentInfoSuccess, loadBenefitsDependentInfoFail, updateBenefitsDependentForm, loadAvailableBenefitPlans, loadAvailableBenefitPlansSuccess, loadAvailableBenefitPlansFail, loadBenefitsDeclineReasonsSuccess, loadBenefitPlanEnrollmentSetList, loadBenefitPlanEnrollmentSetListSuccess, loadBenefitPlanEnrollmentSetListFail, saveBenefitsEnrollment, saveBenefitsEnrollmentSuccess, saveBenefitsEnrollmentFail, loadEmployerContributionSuccess, loadBenefitClasses, loadBenefitClassesSuccess, loadBenefitClassesFail, saveBenefitClass, saveBenefitClassSuccess, saveBenefitClassFail, updateBenefitClassForm, signBenefitsFormDocument, loadBenefitsFormDocumentSuccess, loadBenefitsFormDocument, signBenefitsFormDocumentFailure, getBenefitsFormDocumentsList, getBenefitsFormDocumentsListSuccess, loadBenefitsFormDocumentInfo, loadBenefitsFormDocumentInfoSuccess, signBenefitsFormDocumentSuccess, loadAllBenefitPlans, loadAllBenefitPlansSuccess, loadBenefitsSettingsSuccess, changedBenefitClasses, getBenefitStatusQueue, getBenefitStatusQueueSuccess, getBenefitStatusList, getBenefitStatusListSuccess, exportEmployeeBenefitStatusListToExcel, exportEmployeeBenefitStatusListToExcelSuccess, exportEmployeeBenefitStatusListToExcelFailure, loadBenefitPlanUserWithEnrollmentSet, loadBenefitPlanUserWithEnrollmentSetSuccess, loadBenefitPlanUserWithEnrollmentSetFail, loadHelpGuideSuccess,
  exportEnrollmentListToExcel, exportEnrollmentListToExcelSuccess, exportEnrollmentListToExcelFailure, downloadEnrollmentSignedForms, downloadEnrollmentSignedFormsSuccess, downloadEnrollmentSignedFormsFailure,
  downloadEnrollmentSetSignedForms, downloadEnrollmentSetSignedFormsSuccess, downloadEnrollmentSetSignedFormsFailure,
  getBenefitDeclinedList, getBenefitDeclinedListSuccess,
  getBenefitWithdrawnList,
  getBenefitWithdrawnListSuccess,
  loadWithdrawnReasonsSuccess,
  loadBenefitLogTypesSuccess,
  getBenefitLogList,
  getBenefitLogListSuccess,
  loadBenefitsLifeChangingEventsSuccess,
  getBenefitHsaReport,
  getBenefitHsaReportSuccess,
  exportManageEmployeesListToExcel,
  exportManageEmployeesListToExcelSuccess,
  exportManageEmployeesListToExcelFailure,
  loadCarrierBenfitPlansSuccess,
  exportBenefitHsaReportToExcel,
  exportBenefitHsaReportToExcelSuccess,
  exportBenefitHsaReportToExcelFailure,
  exportBenefitWithdrawnToExcel,
  exportBenefitWithdrawnToExcelSuccess,
  exportBenefitWithdrawnToExcelFailure,
  exportAllDentalSelectEnrollmentListToExcel,
  exportAllDentalSelectEnrollmentListToExcelSuccess,
  exportAllDentalSelectEnrollmentListToExcelFailure,
  loadBenefitsSetDocument,
  loadBenefitsSetDocumentSuccess,
  signBenefitsSetDocument,
  signBenefitsSetDocumentSuccess,
  signBenefitsSetDocumentFailure,
  showEditBenefitsSettings,
  closeEditBenefitsSettings,
  saveBenefitsSettings,
  saveBenefitsSettingsSuccess,
  saveBenefitsSettingsFail,
  closeEditHelpInformation,
  showEditHelpInformation,
} from './benefits.actions';
import { ValidatorRequiredNotEmptyIfBool, ValidatorRequiredNotEmptyIfFalse } from 'src/app/helpers/validators';
import { SelectItem } from 'primeng/api';


export interface BenefitsState {
  benefitPlan: BenefitPlanFullModel;
  formErrors: FormError[];
  loadingBenefitPlan: boolean;
  savingBenefitPlan: boolean;

  carrierBenefitPlanList: CarrierBenefitPlanModel[];
  benefitPlanTypesList: BenefitPlanTypeModel[];
  ellegibilityWaitingPeriodsList: BenefitPlanEllegibilityWaitingPeriodModel[];
  ellegibilityBeginsList: BenefitPlanEllegibilityBeginModel[];
  terminationUponsList: BenefitPlanTerminationUponModel[];
  coverageLevelList: BenefitPlanCoverageLevelModel[];

  loadingBenefitPlanList: boolean;
  benefitPlanList: PagingResultsModel<BenefitPlanModel>;

  loadingBenefitsDependents: boolean;
  benefitsDependentsList: BenefitsDependentModel[];

  benefitsDependentInfo: BenefitsDependentModel;
  loadingBenefitsDependentInfo: boolean;

  availableBenefitPlans: BenefitPlanFullModel[];
  loadingavailableBenefitPlans: boolean;

  declineReasonsOptions: BenefitPlanDeclineReasonModel[];

  benefitPlanEnrollmentSetList: BenefitPlanEnrollmentSetModel[];
  loadingBenefitPlanEnrollmentSetList: boolean;
  
  employerContribution: EmployerContributionModel;

  benefitClass: BenefitClassModel;
  benefitClasses: BenefitClassModel[];
  loadingBenefitClasses: boolean;
  savingBenefitClass: boolean;


  loadingDocBenefit: boolean;
  loadingSignBenefit: boolean;
  docArrayBufferBenefit: ArrayBuffer;
  docSignedArrayBufferBenefit: ArrayBuffer;

  docsListBenefit: BenefitPlanFormDocumentsEnrollmentModel[];
  loadingListBenefit: boolean;


  loadingDocInfoBenefit: boolean;
  docInfoBenefit: BenefitPlanFormDocumentsEnrollmentModel;

  allBenefitPlans: BenefitPlanModel[];
  benefitsSettings: BenefitsSettingsModel;
  editingBenefitsSettings: boolean;
  savingBenefitsSettings: boolean;

  editingHelpInformation: boolean;

  loadingBenefitsQueue: boolean;
  benefitsQueue: PagingResultsModel<BenefitStatusCheckModel>;

  loadingBenefitsList: boolean;
  benefitsList: PagingResultsModel<BenefitStatusCheckModel>;

  loadingHsaList: boolean;
  loadingHsaExcel: boolean;
  hsaList: PagingResultsModel<BenefitHsaReportModel>;
  hsaExcelArrayBuffer: ArrayBuffer;

  logTypes: SelectItem[];
  loadingLogList: boolean;
  logList: PagingResultsModel<BenefitLogReportModel>;

  withdrawnReasons: SelectItem[];
  loadingWithdrawnList: boolean;
  loadingWithdrawnExcel: boolean;
  withdrawnList: PagingResultsModel<BenefitPlanWithdrawnReportModel>;
  withdrawnExcelArrayBuffer: ArrayBuffer;

  loadingDeclinedList: boolean;
  declinedList: PagingResultsModel<BenefitPlanDeclinedReportModel>;

  downloadingSignedDocumentsZipFile: boolean;
  signedDocumentsZipFileArrayBuffer: ArrayBuffer;

  downloadingSignedSetDocumentsZipFile: boolean;
  signedSetDocumentsZipFileArrayBuffer: ArrayBuffer;

  loadingBenefitStatusExcel: boolean;
  benefitStatusExcelArrayBuffer: ArrayBuffer;

  loadingEnrollmentsExcel: boolean;
  enrollmentExcelArrayBuffer: ArrayBuffer;

  savingBenefitEnrollment: boolean;

  benefitPlanUserWithEnrollmentSetList: PagingResultsModel<BenefitPlanUserWithEnrollmentSetModel>;
  loadingBenefitPlanUserWithEnrollmentSetList: boolean;

  docArrayBufferBenefitHelpGuide: ArrayBuffer;
  benefitsLifeChangingEvents: BenefitsLifeChangingEventModel[];

  loadingManageEmployeesListToExcel: boolean;
  manageEmployeesListToExcelArrayBuffer: ArrayBuffer;
}

const initialState: BenefitsState = {
  benefitPlan: null,
  formErrors: [],
  loadingBenefitPlan: false,
  savingBenefitPlan: false,

  carrierBenefitPlanList: [],
  benefitPlanTypesList: [],
  ellegibilityWaitingPeriodsList: [],
  ellegibilityBeginsList: [],
  terminationUponsList: [],
  coverageLevelList: [],

  loadingBenefitPlanList: false,
  benefitPlanList: null,

  loadingBenefitsDependents: false,
  benefitsDependentsList: [],
  benefitsDependentInfo: null,
  loadingBenefitsDependentInfo: false,
  availableBenefitPlans: [],
  loadingavailableBenefitPlans: false,
  declineReasonsOptions: [],

  savingBenefitEnrollment: false,

  benefitPlanEnrollmentSetList: null,
  loadingBenefitPlanEnrollmentSetList: false,
    
  employerContribution: null,

  benefitClass: null,
  benefitClasses: [],
  loadingBenefitClasses: false,
  savingBenefitClass: false,


  loadingDocBenefit: false,
  loadingSignBenefit: false,
  docArrayBufferBenefit: null,
  docSignedArrayBufferBenefit: null,

  docsListBenefit: [],
  loadingListBenefit: false,


  loadingDocInfoBenefit: false,
  docInfoBenefit: null,
  allBenefitPlans: [],
  benefitsSettings: null,
  editingBenefitsSettings: false,
  savingBenefitsSettings: false,
  editingHelpInformation: false,
  loadingBenefitsQueue: true,
  benefitsQueue: null,

  loadingHsaList: true,
  loadingHsaExcel: false,
  hsaList: null,
  hsaExcelArrayBuffer: null,

  loadingBenefitsList: true,
  benefitsList: null,

  logTypes: [],
  loadingLogList: true,
  logList: null,

  withdrawnReasons: [],
  loadingWithdrawnList: true,
  loadingWithdrawnExcel: false,
  withdrawnList: null,
  withdrawnExcelArrayBuffer: null,

  loadingDeclinedList: true,
  declinedList: null,

  downloadingSignedDocumentsZipFile: false,
  signedDocumentsZipFileArrayBuffer: null,

  downloadingSignedSetDocumentsZipFile: false,
  signedSetDocumentsZipFileArrayBuffer: null,

  loadingBenefitStatusExcel: false,
  benefitStatusExcelArrayBuffer: null,

  loadingEnrollmentsExcel: false,
  enrollmentExcelArrayBuffer: null,

  benefitPlanUserWithEnrollmentSetList: null,
  loadingBenefitPlanUserWithEnrollmentSetList: false,
  docArrayBufferBenefitHelpGuide: null,


  benefitsLifeChangingEvents: null,

  loadingManageEmployeesListToExcel: false,
  manageEmployeesListToExcelArrayBuffer: null,
};

export const benefitsReducer = createReducer(initialState,
  on(loadBenefitsPlanInfo, (state, action) => (
    {
      ...state,
      benefitPlan: null,
      formErrors: [],
      loadingBenefitPlan: true
    })),
  on(loadBenefitsPlanInfoSuccess, (state, action) => {
    let formErrors;
    if (action.benefitPlan) {
      const form = initBenefitPlanForm(action.benefitPlan.benefitPlan);
      formErrors = getAllControlsErrors(form);
    }
    return {
      ...state,
      benefitPlan: action.benefitPlan,
      formErrors,
      loadingBenefitPlan: false,
    };
  }),
  on(loadBenefitsPlanInfoFail, (state, action) => ({ ...state, loadingBenefitPlan: false })),

  on(updateBenefitsPlanForm, (state, action) => {
    const newBenefitPlan = { ...state.benefitPlan ? state.benefitPlan.benefitPlan : {}, ...action.benefitPlanValues };
    const newBenefitPlanFull = { ...state.benefitPlan, ...{ benefitPlan: newBenefitPlan } };
    const newState = { ...state, ...{ benefitPlan: newBenefitPlanFull, formErrors: action.formErrors } };
    return newState;
  }),
  on(saveBenefitsPlan, (state, action) => ({ ...state, savingBenefitPlan: true })),
  on(saveBenefitsPlanSuccess, (state, action) => ({ ...state, savingBenefitPlan: false })),
  on(saveBenefitsPlanFail, (state, action) => ({ ...state, savingBenefitPlan: false })),

  on(loadBenefitsPlans, (state, action) => ({ ...state, loadingBenefitPlanList: true })),
  on(loadBenefitsPlansSuccess, (state, action) => {
    return {
      ...state,
      benefitPlanList: action.benefitPlanList,
      loadingBenefitPlanList: false,
    };
  }),
  on(loadBenefitsPlansFail, (state, action) => ({ ...state, loadingBenefitPlanList: false })),
  on(clearBenefitsPlanInfo, (state, action) => ({ ...state, benefitPlan: null })),

  on(loadCarrierBenfitPlansSuccess, (state, action) => {
    return {
      ...state,
      carrierBenefitPlanList: action.carrierBenefitPlanList,
    };
  }),
  on(loadBenfitPlanTypesSuccess, (state, action) => {
    return {
      ...state,
      benefitPlanTypesList: action.benefitPlanTypesList,
    };
  }),
  on(loadElegibilityWaitingPeriodsSuccess, (state, action) => {
    return {
      ...state,
      ellegibilityWaitingPeriodsList: action.ellegibilityWaitingPeriodsList,
    };
  }),
  on(loadElegibilityBeginsSuccess, (state, action) => {
    return {
      ...state,
      ellegibilityBeginsList: action.ellegibilityBeginsList,
    };
  }),
  on(loadTerminationUponsSuccess, (state, action) => {
    return {
      ...state,
      terminationUponsList: action.terminationUponsList,
    };
  }),
  on(loadCoverageLevelsSuccess, (state, action) => {
    return {
      ...state,
      coverageLevelList: action.coverageLevelList,
    };
  }),

  on(addBenefitPlanDocument, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (!benefitPlan.documents) {
      benefitPlan.documents = [];
    }
    benefitPlan.documents.push(action.document);
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),

  on(removeBenefitPlanDocument, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (benefitPlan.documents) {
      const index = benefitPlan.documents.findIndex(x => x.file === action.document.file
        && x.documentName === action.document.documentName);
      if (index >= 0) {
        benefitPlan.documents.splice(index, 1);
      }
    }
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),


  on(addBenefitPlanLink, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (!benefitPlan.links) {
      benefitPlan.links = [];
    }
    benefitPlan.links.push(action.link);
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),

  on(removeBenefitPlanLink, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (benefitPlan.links) {
      const index = benefitPlan.links.findIndex(x => x.url === action.link.url
        && x.linkName === action.link.linkName);
      if (index >= 0) {
        benefitPlan.links.splice(index, 1);
      }
    }
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),

  on(addBenefitPlanCost, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (!benefitPlan.costs) {
      benefitPlan.costs = [];
    }
    let index = benefitPlan.costs.findIndex((x) => x.coverageLevelID === action.cost.coverageLevelID);
    if (index >= 0)
      benefitPlan.costs.splice(index, 1, action.cost);
    else
      benefitPlan.costs.push(action.cost);
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),

  on(removeBenefitPlanCost, (state, action) => {
    const benefitPlan: BenefitPlanFullModel = state.benefitPlan ? deepClone(state.benefitPlan) : {};
    if (benefitPlan.costs) {
      const index = benefitPlan.costs.findIndex(x => x.coverageLevelID === action.cost.coverageLevelID);
      if (index >= 0) {
        benefitPlan.costs.splice(index, 1);
      }
    }
    const newState = { ...state, ...{ benefitPlan } };
    return newState;
  }),


  on(loadBenefitsDependents, (state, action) => ({ ...state, loadingBenefitsDependents: true })),
  on(loadBenefitsDependentsSuccess, (state, action) => {
    return {
      ...state,
      benefitsDependentsList: action.benefitsDependents,
      loadingBenefitsDependents: false,
    };
  }),
  on(loadBenefitsDependentsFail, (state, action) => ({ ...state, loadingBenefitsDependents: false })),




  on(loadBenefitsDependentInfo, (state, action) => ({ ...state, loadingBenefitsDependentInfo: true })),
  on(loadBenefitsDependentInfoSuccess, (state, action) => {
    return {
      ...state,
      benefitsDependentInfo: action.benefitsDependentInfo,
      loadingBenefitsDependentInfo: false,
    };
  }),
  on(loadBenefitsDependentInfoFail, (state, action) => ({ ...state, loadingBenefitsDependentInfo: false })),


  on(updateBenefitsDependentForm, (state, action) => {
    const newBenefitsDependentInfo = { ...state.benefitsDependentInfo, ...action.benefitsDependentValues };
    const newState = { ...state, ...{ benefitsDependentInfo: newBenefitsDependentInfo, formErrors: action.formErrors } };
    return newState;
  }),


  on(loadAvailableBenefitPlans, (state, action) => ({ ...state, loadingavailableBenefitPlans: true })),
  on(loadAvailableBenefitPlansSuccess, (state, action) => {
    return {
      ...state,
      availableBenefitPlans: action.availableBenefitPlans,
      loadingavailableBenefitPlans: false,
    };
  }),
  on(loadAvailableBenefitPlansFail, (state, action) => ({ ...state, loadingavailableBenefitPlans: false })),

  on(loadBenefitsDeclineReasonsSuccess, (state, action) => {
    return {
      ...state,
      declineReasonsOptions: action.benefitDeclineReasons,
    };
  }),




  on(loadBenefitPlanEnrollmentSetList, (state, action) => ({ ...state, loadingBenefitPlanEnrollmentSetList: true })),
  on(loadBenefitPlanEnrollmentSetListSuccess, (state, action) => {
    return {
      ...state,
      benefitPlanEnrollmentSetList: action.benefitPlanEnrollmentSetList,
      loadingBenefitPlanEnrollmentSetList: false,
    };
  }),
  on(loadBenefitPlanEnrollmentSetListFail, (state, action) => ({ ...state, loadingBenefitPlanEnrollmentSetList: false })),
  
  on(saveBenefitsEnrollment, (state, action) => ({ ...state, savingBenefitEnrollment: true })),
  on(saveBenefitsEnrollmentSuccess, (state, action) => {

    const benefitPlanEnrollmentSetList = state.benefitPlanEnrollmentSetList ? state.benefitPlanEnrollmentSetList  : [];

    let index = benefitPlanEnrollmentSetList.findIndex(x => x.id === action.enrollmentSet.id);
    if (index == -1)
      benefitPlanEnrollmentSetList.push(action.enrollmentSet);
    else
      benefitPlanEnrollmentSetList.splice(index, 1, action.enrollmentSet);
 
    return {
      ...state,
      benefitPlanEnrollmentSetList: benefitPlanEnrollmentSetList,
      savingBenefitEnrollment: false
    };
  }),
  on(saveBenefitsEnrollmentFail, (state, action) => ({ ...state, savingBenefitEnrollment: false })),

  on(loadEmployerContributionSuccess, (state, action) => {
    return {
      ...state,
      employerContribution: action.employerContribution,
    };
  }),


  on(loadBenefitClasses, (state, action) => ({ ...state, loadingBenefitClasses: true })),
  on(loadBenefitClassesSuccess, (state, action) => {
    return {
      ...state,
      benefitClasses: action.benefitClasses,
      loadingBenefitClasses: false,
    };
  }),
  on(loadBenefitClassesFail, (state, action) => ({ ...state, loadingBenefitClasses: false })),


  on(saveBenefitClass, (state, action) => ({ ...state, savingBenefitClass: true })),
  on(saveBenefitClassSuccess, (state, action) => ({ ...state, savingBenefitClass: false })),
  on(saveBenefitClassFail, (state, action) => ({ ...state, savingBenefitClass: false })),


  on(updateBenefitClassForm, (state, action) => {
    const newBenefitClass = { ...state.benefitClass, ...action.benefitClassValues };
    const newState = { ...state, ...{ benefitClass: newBenefitClass, formErrors: action.formErrors } };
    return newState;
  }),


  on(loadBenefitsFormDocument, (state, action) => {
    return {
      ...state,
      loadingDocBenefit: true,
      docArrayBufferBenefit: null
    };
  }),
  on(loadBenefitsFormDocumentSuccess, (state, action) => {
    return {
      ...state,
      docArrayBufferBenefit: action.doc,
      loadingDocBenefit: false
    };
  }),
  on(signBenefitsFormDocument, (state, action) => {
    return {
      ...state,
      loadingSignBenefit: true,
      docSignedArrayBufferBenefit: null
    };
  }),
  on(signBenefitsFormDocumentSuccess, (state, action) => {
    return {
      ...state,
      docSignedArrayBufferBenefit: action.docSigned,
      loadingSignBenefit: false
    };
  }),
  on(signBenefitsFormDocumentFailure, (state, action) => {
    return {
      ...state,
      loadingSignBenefit: false
    };
  }),



  on(loadBenefitsSetDocument, (state, action) => {
    return {
      ...state,
      loadingDocBenefit: true,
      docArrayBufferBenefit: null
    };
  }),
  on(loadBenefitsSetDocumentSuccess, (state, action) => {
    return {
      ...state,
      docArrayBufferBenefit: action.doc,
      loadingDocBenefit: false
    };
  }),
  on(signBenefitsSetDocument, (state, action) => {
    return {
      ...state,
      loadingSignBenefit: true,
      docSignedArrayBufferBenefit: null
    };
  }),
  on(signBenefitsSetDocumentSuccess, (state, action) => {
    return {
      ...state,
      docSignedArrayBufferBenefit: action.docSigned,
      loadingSignBenefit: false
    };
  }),
  on(signBenefitsSetDocumentFailure, (state, action) => {
    return {
      ...state,
      loadingSignBenefit: false
    };
  }),


  on(getBenefitsFormDocumentsList, (state, action) => {
    return {
      ...state,
      loadingListBenefit: true
    };
  }),
  on(getBenefitsFormDocumentsListSuccess, (state, action) => {
    return {
      ...state,
      docsListBenefit: action.docs,
      loadingListBenefit: false
    };
  }),

  on(loadBenefitsFormDocumentInfo, (state, action) => {
    return {
      ...state,
      loadingDocInfoBenefit: true,
      docInfoBenefit: null
    };
  }),
  on(loadBenefitsFormDocumentInfoSuccess, (state, action) => {
    return {
      ...state,
      docInfoBenefit: action.doc,
      loadingDocInfoBenefit: false
    };
  }),
  on(loadAllBenefitPlans, (state, action) => {
    return {
      ...state,
      allBenefitPlans: null
    };
  }),
  on(loadAllBenefitPlansSuccess, (state, action) => {
    return {
      ...state,
      allBenefitPlans: action.allBenefitPlans,
    };
  }),

  on(loadBenefitsSettingsSuccess, (state, action) => {
    return {
      ...state,
      benefitsSettings: action.benefitsSettings,
    };
  }),

  on(changedBenefitClasses, (state, action) => {
    const newBenefitPlan = { ...state.benefitPlan, ...{ classes: action.classes } };
    return {
      ...state,
      benefitPlan: newBenefitPlan
    };
  }),
  on(getBenefitHsaReport, (state, action) => {
    return {
      ...state,
      loadingHsaList: true
    };
  }),
  on(getBenefitHsaReportSuccess, (state, action) => {
    return {
      ...state,
      loadingHsaList: false,
      hsaList: action.list
    };
  }),
  on(getBenefitStatusQueue, (state, action) => {
    return {
      ...state,
      loadingBenefitsQueue: true
    };
  }),
  on(getBenefitStatusQueueSuccess, (state, action) => {
    return {
      ...state,
      loadingBenefitsQueue: false,
      benefitsQueue: action.queue
    };
  }),
  on(loadBenefitLogTypesSuccess, (state, action) => {
    return {
      ...state,
      logTypes: action.types,
    };
  }),
  on(getBenefitLogList, (state, action) => {
    return {
      ...state,
      loadingLogList: true
    };
  }),
  on(getBenefitLogListSuccess, (state, action) => {
    return {
      ...state,
      loadingLogList: false,
      logList: action.list
    };
  }),
  on(loadWithdrawnReasonsSuccess, (state, action) => {
    return {
      ...state,
      withdrawnReasons: action.reasons,
    };
  }),
  on(getBenefitWithdrawnList, (state, action) => {
    return {
      ...state,
      loadingWithdrawnList: true
    };
  }),
  on(getBenefitWithdrawnListSuccess, (state, action) => {
    return {
      ...state,
      loadingWithdrawnList: false,
      withdrawnList: action.list
    };
  }),
  on(getBenefitDeclinedList, (state, action) => {
    return {
      ...state,
      loadingDeclinedList: true
    };
  }),
  on(getBenefitDeclinedListSuccess, (state, action) => {
    return {
      ...state,
      loadingDeclinedList: false,
      declinedList: action.list
    };
  }),
  on(getBenefitStatusList, (state, action) => {
    return {
      ...state,
      loadingBenefitsList: true
    };
  }),
  on(getBenefitStatusListSuccess, (state, action) => {
    return {
      ...state,
      loadingBenefitsList: false,
      benefitsList: action.list
    };
  }),
  on(downloadEnrollmentSetSignedForms, (state, action) => {
    return {
      ...state,
      downloadingSignedSetDocumentsZipFile: true,
      signedSetDocumentsZipFileArrayBuffer: null
    };
  }),
  on(downloadEnrollmentSetSignedFormsSuccess, (state, action) => {
    return {
      ...state,
      downloadingSignedSetDocumentsZipFile: false,
      signedSetDocumentsZipFileArrayBuffer: action.doc
    };
  }),
  on(downloadEnrollmentSetSignedFormsFailure, (state, action) => {
    return {
      ...state,
      downloadingSignedSetDocumentsZipFile: false
    };
  }),
  on(downloadEnrollmentSignedForms, (state, action) => {
    return {
      ...state,
      downloadingSignedDocumentsZipFile: true,
      signedDocumentsZipFileArrayBuffer: null
    };
  }),
  on(downloadEnrollmentSignedFormsSuccess, (state, action) => {
    return {
      ...state,
      downloadingSignedDocumentsZipFile: false,
      signedDocumentsZipFileArrayBuffer: action.doc
    };
  }),
  on(downloadEnrollmentSignedFormsFailure, (state, action) => {
    return {
      ...state,
      downloadingSignedDocumentsZipFile: false
    };
  }),
  on(exportEnrollmentListToExcel, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: true,
      enrollmentExcelArrayBuffer: null
    };
  }),
  on(exportEnrollmentListToExcelSuccess, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: false,
      enrollmentExcelArrayBuffer: action.doc
    };
  }),
  on(exportEnrollmentListToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: false
    };
  }),
  on(exportAllDentalSelectEnrollmentListToExcel, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: true,
      enrollmentExcelArrayBuffer: null
    };
  }),
  on(exportAllDentalSelectEnrollmentListToExcelSuccess, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: false,
      enrollmentExcelArrayBuffer: action.doc
    };
  }),
  on(exportAllDentalSelectEnrollmentListToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingEnrollmentsExcel: false
    };
  }),
  on(exportEmployeeBenefitStatusListToExcel, (state, action) => {
    return {
      ...state,
      loadingBenefitStatusExcel: true,
      benefitStatusExcelArrayBuffer: null
    };
  }),
  on(exportEmployeeBenefitStatusListToExcelSuccess, (state, action) => {
    return {
      ...state,
      benefitStatusExcelArrayBuffer: action.doc,
      loadingBenefitStatusExcel: false
    };
  }),
  on(exportEmployeeBenefitStatusListToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingBenefiteStatusExcel: false
    };
  }),
  on(exportBenefitHsaReportToExcel, (state, action) => {
    return {
      ...state,
      loadingHsaExcel: true,
      hsaExcelArrayBuffer: null
    };
  }),
  on(exportBenefitHsaReportToExcelSuccess, (state, action) => {
    return {
      ...state,
      loadingHsaExcel: false,
      hsaExcelArrayBuffer: action.doc
    };
  }),
  on(exportBenefitHsaReportToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingHsaExcel: false
    };
  }),
  on(exportBenefitWithdrawnToExcel, (state, action) => {
    return {
      ...state,
      loadingWithdrawnExcel: true,
      withdrawnExcelArrayBuffer: null
    };
  }),
  on(exportBenefitWithdrawnToExcelSuccess, (state, action) => {
    return {
      ...state,
      loadingWithdrawnExcel: false,
      withdrawnExcelArrayBuffer: action.doc
    };
  }),
  on(exportBenefitWithdrawnToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingWithdrawnExcel: false
    };
  }),
  on(loadBenefitPlanUserWithEnrollmentSet, (state, action) => {
    return {
      ...state,
      loadingBenefitPlanUserWithEnrollmentSetList: true,
      benefitPlanUserWithEnrollmentSetList: null,
    };
  }),
  on(loadBenefitPlanUserWithEnrollmentSetSuccess, (state, action) => {
    return {
      ...state,
      benefitPlanUserWithEnrollmentSetList: action.benefitPlanUserWithEnrollmentSetList,
      loadingBenefitPlanUserWithEnrollmentSetList: false
    };
  }),
  on(loadBenefitPlanUserWithEnrollmentSetFail, (state, action) => {
    return {
      ...state,
      loadingBenefitPlanUserWithEnrollmentSetList: false
    };
  }),

  on(loadHelpGuideSuccess, (state, action) => {
    return {
      ...state,
      docArrayBufferBenefitHelpGuide: action.doc,
    };
  }),

  on(loadBenefitsLifeChangingEventsSuccess, (state, action) => {
    return {
      ...state,
      benefitsLifeChangingEvents: action.benefitsLifeChangingEvents,
    };
  }),

  on(exportManageEmployeesListToExcel, (state, action) => {
    return {
      ...state,
      loadingManageEmployeesListToExcel: true,
      manageEmployeesListToExcelArrayBuffer: null
    };
  }),

  on(exportManageEmployeesListToExcelSuccess, (state, action) => {
    return {
      ...state,
      manageEmployeesListToExcelArrayBuffer: action.doc,
      loadingManageEmployeesListToExcel: false
    };
  }),
  on(exportManageEmployeesListToExcelFailure, (state, action) => {
    return {
      ...state,
      loadingManageEmployeesListToExcel: false
    };
  }),

  on(showEditBenefitsSettings, (state, action) => {
    return {
      ...state,      
      editingBenefitsSettings: true
    };
  }),
  on(closeEditBenefitsSettings, (state, action) => {
    return {
      ...state,
      editingBenefitsSettings: false
    };
  }),
  on(showEditHelpInformation, (state, action) => {
    return {
      ...state,      
      editingHelpInformation: true
    };
  }),
  on(closeEditHelpInformation, (state, action) => {
    return {
      ...state,
      editingHelpInformation: false
    };
  }),
  on(saveBenefitsSettings, (state, action) => {
    return {
      ...state,
      savingBenefitsSettings: true
    }
  }),
  on(saveBenefitsSettingsSuccess, (state, action) => {
    return {
      ...state,
      savingBenefitsSettings: false
    }
  }),
  on(saveBenefitsSettingsFail, (state, action) => {
    return {
      ...state,
      savingBenefitsSettings: false
    }
  }),

);

export function benefitsReducerFunc(state: BenefitsState | undefined, action: Action) {
  return benefitsReducer(state, action);
}


export function initBenefitPlanForm(benefitPlan: BenefitPlanModel) {

  const januaryFirst = new Date(new Date().getFullYear(), 0, 1);
  const december31 = new Date(new Date().getFullYear(), 11, 31);
  const form = new UntypedFormGroup({
    planName: new UntypedFormControl(benefitPlan.planName, [Validators.required, Validators.maxLength(255)]),
    active: new UntypedFormControl(benefitPlan.active, []),
    allowHSA: new UntypedFormControl(benefitPlan.allowHSA, []),
    benefitPlanTypeID: new UntypedFormControl(benefitPlan.benefitPlanTypeID, [Validators.required]),
    carrierPlanID: new UntypedFormControl(benefitPlan.carrierPlanID, [Validators.required]),
    //carrier: new FormControl(benefitPlan.carrier, [Validators.required, Validators.maxLength(255)]),
    //carrierPlanName: new FormControl(benefitPlan.carrierPlanName, [Validators.required, Validators.maxLength(255)]),
    dateEnd: new UntypedFormControl(benefitPlan.dateEnd ? new Date(benefitPlan.dateEnd) : december31, [Validators.required]),
    dateStart: new UntypedFormControl(benefitPlan.dateStart ? new Date(benefitPlan.dateStart) : januaryFirst, [Validators.required]),
    dependOnPlanID: new UntypedFormControl(benefitPlan.dependOnPlanID, []),
    disclosure: new UntypedFormControl(benefitPlan.disclosure, [Validators.maxLength(2000)]),
    elegibleYearlyContribution: new UntypedFormControl(benefitPlan.elegibleYearlyContribution, []),
    ellegibilityBeginID: new UntypedFormControl(benefitPlan.ellegibilityBeginID, [Validators.required]),
    ellegibilityWaitingPeriodID: new UntypedFormControl(benefitPlan.ellegibilityWaitingPeriodID, [Validators.required]),
    policyNumber: new UntypedFormControl(benefitPlan.policyNumber, [Validators.required]),
    renewalDate: new UntypedFormControl(benefitPlan.renewalDate ? new Date(benefitPlan.renewalDate) : null, [Validators.required]),
    summary: new UntypedFormControl(benefitPlan.summary, [Validators.required, Validators.maxLength(2000)]),
    terminationUponID: new UntypedFormControl(benefitPlan.terminationUponID, [Validators.required]),
    specialPercentageContribution: new UntypedFormControl(benefitPlan.specialPercentageContribution, [Validators.min(0), Validators.max(100)]),
    paylocityDeductionCode: new UntypedFormControl(benefitPlan.paylocityDeductionCode, [Validators.maxLength(50)]),
    paylocityEarningCode: new UntypedFormControl(benefitPlan.paylocityEarningCode, [Validators.maxLength(50)]),
    motivHealthPlanCoverage: new UntypedFormControl(benefitPlan.motivHealthPlanCoverage, [Validators.maxLength(50)]),
    sameraHealthPlanCoverage: new UntypedFormControl(benefitPlan.sameraHealthPlanCoverage, [Validators.maxLength(50)]),
    sameraHealthPlanType: new UntypedFormControl(benefitPlan.sameraHealthPlanType, [Validators.maxLength(10)]),
    isCobraEligible: new UntypedFormControl(benefitPlan.isCobraEligible, []),
    cobraPlanName: new UntypedFormControl(benefitPlan.cobraPlanName, [Validators.maxLength(255)]),
    familyYearlyContribution: new UntypedFormControl(benefitPlan.familyYearlyContribution, []),
    catchUpContribution: new UntypedFormControl(benefitPlan.catchUpContribution, []),
    catchUpContributionStartingAge: new UntypedFormControl(benefitPlan.catchUpContributionStartingAge, [])
  });

  return form;
}


export function initBenefitsDependentForm(benefitsDependent: BenefitsDependentModel) {

  const januaryFirst = new Date(new Date().getFullYear(), 0, 1);
  const december31 = new Date(new Date().getFullYear(), 11, 31);
  const form = new UntypedFormGroup({
    id: new UntypedFormControl(benefitsDependent.id),
    address: new UntypedFormControl(benefitsDependent.address, [Validators.maxLength(255)]),
    addressExtra: new UntypedFormControl(benefitsDependent.addressExtra, [Validators.maxLength(255)]),
    city: new UntypedFormControl(benefitsDependent.city, [Validators.maxLength(255)]),
    collegeStartDate: new UntypedFormControl(benefitsDependent.collegeStartDate ? new Date(benefitsDependent.collegeStartDate) : null, []),
    country: new UntypedFormControl(benefitsDependent.country, [Validators.maxLength(255)]),
    county: new UntypedFormControl(benefitsDependent.county, [Validators.maxLength(255)]),
    dateOfBirth: new UntypedFormControl(benefitsDependent.dateOfBirth ? new Date(benefitsDependent.dateOfBirth) : null, [Validators.required]),
    disabled: new UntypedFormControl(!!benefitsDependent.disabledDate, []),
    disabledDate: new UntypedFormControl(benefitsDependent.disabledDate ? new Date(benefitsDependent.disabledDate) : null, []),
    expectedGraduationDate:
      new UntypedFormControl(benefitsDependent.expectedGraduationDate ? new Date(benefitsDependent.expectedGraduationDate) : null, []),
    firstName: new UntypedFormControl(benefitsDependent.firstName, [Validators.required, Validators.maxLength(255)]),
    gender: new UntypedFormControl(benefitsDependent.gender, [Validators.required]),
    isAddressSame: new UntypedFormControl(benefitsDependent.isAddressSame, []),
    isFullTimeCollegeStudent: new UntypedFormControl(benefitsDependent.isFullTimeCollegeStudent, []),
    isTobbacoUser: new UntypedFormControl(benefitsDependent.isTobbacoUser, []),
    lastName: new UntypedFormControl(benefitsDependent.lastName, [Validators.required, Validators.maxLength(255)]),
    middleName: new UntypedFormControl(benefitsDependent.middleName, [Validators.maxLength(255)]),
    province: new UntypedFormControl(benefitsDependent.province, [Validators.maxLength(255)]),
    relationship: new UntypedFormControl(benefitsDependent.relationship, [Validators.required, Validators.maxLength(255)]),
    ssn: new UntypedFormControl(benefitsDependent.ssn, [Validators.required, Validators.pattern(/^\s*(?:[0-9]{9}|[0-9]{3}-[0-9]{2}-[0-9]{4})\s*$/)]),
    state: new UntypedFormControl(benefitsDependent.state, [Validators.maxLength(255)]),
    suffixName: new UntypedFormControl(benefitsDependent.suffixName, [Validators.maxLength(255)]),
    zipCode: new UntypedFormControl(benefitsDependent.zipCode, [Validators.maxLength(255)]),
    email: new UntypedFormControl(benefitsDependent.email, [Validators.maxLength(255), Validators.email]),
    phone: new UntypedFormControl(benefitsDependent.phone, [Validators.maxLength(50), Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$')]),

  }, [ValidatorRequiredNotEmptyIfBool('collegeStartDate', 'isFullTimeCollegeStudent'),
  ValidatorRequiredNotEmptyIfBool('expectedGraduationDate', 'isFullTimeCollegeStudent'),
  ValidatorRequiredNotEmptyIfFalse('address', 'isAddressSame'),
  ValidatorRequiredNotEmptyIfFalse('state', 'isAddressSame'),
  ValidatorRequiredNotEmptyIfFalse('zipCode', 'isAddressSame'),
  ]);

  return form;
}
export function initBenefitClassForm(benefitClass: BenefitClassModel) {

  const form = new UntypedFormGroup({
    id: new UntypedFormControl(benefitClass.id),
    class: new UntypedFormControl(benefitClass.class, [Validators.maxLength(255)]),
    employerContribution: new UntypedFormControl(benefitClass.employerContribution),
  });

  return form;
}

